<template>
	<teleport to="body">
		<!-- 1. 给遮罩层添加点击事件 handleMaskClick -->
		<div class="modal-mask" v-if="visible" @click="handleMaskClick()">
			<!-- 2. 给弹窗容器添加点击事件阻止冒泡 -->
			<div class="modal-container" @click.stop>
				<div class="modal-header">
					<span>{{ title }}</span>
					<button @click="handleClose()">×</button>
				</div>
				<div class="modal-body" style="width: 50vw;height: 40vh;">
					<div
						style="display: flex;align-items: center;padding: 2% 7%;font: 1.1em sans-serif;color: #787878;">
						<div>{{routeData.cpName}}</div>
						<div style="left: 2%;position: relative;">{{waybillNo}}</div>
						<el-button @click="$commonFunction.copy(waybillNo)"
							style="left: 2.5%;position: relative;" type="text" icon="el-icon-copy-document"></el-button>
					</div>
					<div>
						<el-timeline :reverse="true">
							<el-timeline-item v-for="(i, index) in routeData.route" :key="index" :timestamp="i.time"
								:color="ifDropColor(index,routeData.route.length)">
								<span>{{i.opcode}}</span>
								<div :style="{color:(index==routeData.route.length-1?'#409EFF':'#949494')}" style="line-height: 1.8em;">{{i.text}}
								</div>
							</el-timeline-item>
						</el-timeline>
						<el-empty v-if="routeData.route.length<1" description="暂无数据"></el-empty>
					</div>
				</div>
				<!-- <div class="modal-footer">
          <button @click="handleClose()">关闭</button>
        </div> -->
			</div>
		</div>
	</teleport>
</template>

<script>
	import {
		ElMessage,
		ElTimeline,
		ElTimelineItem,
		ElEmpty
	} from 'element-plus'
	import apiService from "../../../../src/util/apiService.js"
	export default {
		components: {
			ElTimeline,
			ElTimelineItem,
			ElEmpty
		},
		// 选项式API：定义接收的属性
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '运单查询'
			},
			cpCode: {
				type: String,
				default: ''
			},
			waybillNo: {
				type: String,
				default: ''
			},
			phone: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				empty: false,
				routeData: {
					cpName: "",
					waybillNo: "",
					route: [],
				},
			}
		},
		// 也可以在mounted中打印（组件挂载时）
		mounted() {
			// 因为visible初始可能为false，这里加个判断
			if (this.visible) {
				this.queryWaybill(this.cpCode, this.waybillNo, this.phone)
			}
		},
		// 选项式API：定义方法
		methods: {
			queryWaybill(cpCode, waybillNo, phone) {
				// console.log(cpCode, waybillNo, phone)
				//判断运单号是否大于十个字符
				if (waybillNo) {
					//初始化
					this.routeData = {
						cpName: "",
						waybillNo: "",
						route: [],
					}
					this.empty = false;
					var content = {
						cpCode: cpCode,
						waybillNo: waybillNo,
						phone: phone
					};
					apiService.post({
							modules: "waybillRoute",
							content: content
						})
						.then((res) => {
							//成功
							if (res.status) {
								this.routeData = res.data;
								if (this.routeData.route.length < 1) {
									this.empty = true;
								}
								console.log(this.routeData)
							}
						})
					this.empty = false;
				} else {
					this.handleClose();
					ElMessage.error('请传入运单号');
				}
			},
			ifDropColor(index, length) {
				if (index == length - 1) {
					return '#5389ff'
				} else {
					return '#e4e7ed'
				}
			},
			// 3. 新增遮罩层点击事件处理方法
			handleMaskClick() {
				this.handleClose()
			},
			handleClose() {
				// 触发close事件
				this.$emit('close')
			}
		},
		// 选项式API：监听属性变化
		watch: {
			visible(newVal) {
				console.log('弹窗状态变化：', newVal)
			}
		}
	}
</script>

<style scoped>
	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.modal-container {
		/* width: 400px; */
		/* max-width: 90vw; */
		/* 适配小屏幕，防止弹窗超出视口 */
		background: white;
		border-radius: 8px;
		/* padding: 16px; */
		/* 关键：设置最大高度，防止整个弹窗超出视口 */
		max-height: 80vh;
		/* 弹性布局，让body区域自动填充剩余空间 */
		display: flex;
		flex-direction: column;
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		/* margin-bottom: 16px; */
		border-bottom: 1px solid #eee;
		padding-bottom: 8px;
		/* 固定头部高度，不参与滚动 */
		flex-shrink: 0;
		background-color: #007aff;
		padding: 10px;
		color: #fff;
		border-radius: 8px 8px 0 0;
	}

	.modal-header span {
		position: relative;
		width: 100%;
		text-align: center;
		font-size: 1.1em;
		font-family: sans-serif;
		font-weight: 400;
	}

	.modal-header button {
		background: transparent;
		border: none;
		font-size: 1.5em;
		cursor: pointer;
		color: #fff;
		position: relative;
		right: 2%;
	}

	/* 核心修改：解决内容溢出问题 */
	.modal-body {
		/* 自动填充剩余空间 */
		flex: 1;
		/* 设置最大高度，超出则滚动 */
		/* max-height: 300px; */
		/* 溢出自动显示滚动条 */
		overflow-y: auto;
		/* 优化滚动条样式（可选，提升体验） */
		/* scrollbar-width: thin;
		scrollbar-color: #ccc #f5f5f5; */
		margin: 20px;
	}



	/* .modal-footer {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

.modal-footer button {
  padding: 6px 12px;
  background: #1989fa;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
} */
</style>
<style>
/* 1. 缩窄滚动条宽度 */
.modal-body::-webkit-scrollbar {
  width: 3px !important;
  height: 3px !important;
}

/* 2. 隐藏滚动条上下箭头（关键！） */
.modal-body::-webkit-scrollbar-button {
  display: none !important; /* 完全隐藏箭头按钮 */
}

/* 3. 隐藏滚动条轨道 */
.modal-body::-webkit-scrollbar-track {
  background: transparent !important;
  border-radius: 3px !important;
}

/* 4. 圆滑透明滑块 */
.modal-body::-webkit-scrollbar-thumb {
  background: rgba(224, 224, 224, 0.3) !important;
  border-radius: 3px !important;
  border: none !important;
}

/* 5. hover加深透明度 */
.modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(224, 224, 224, 0.3) !important;
}

/* 6. Firefox适配（Firefox默认无滚动条箭头，无需额外处理） */
.modal-body {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(224, 224, 224, 0.3) transparent !important;
}
</style>